// Build-time feature flags, controlled via REACT_APP_* variables in the .env files.
// See package.json scripts: build (full app), build:coming-soon, build:landing-only.
export const isComingSoon = process.env.REACT_APP_COMING_SOON === 'true';
export const isLandingOnly = process.env.REACT_APP_LANDING_ONLY === 'true';
